import { render, staticRenderFns } from "./ProjectAmount.vue?vue&type=template&id=ad0cd8c2&scoped=true&"
import script from "./ProjectAmount.vue?vue&type=script&lang=js&"
export * from "./ProjectAmount.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAmount.vue?vue&type=style&index=0&id=ad0cd8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0cd8c2",
  null
  
)

export default component.exports